module.exports = __webpack_public_path__ + "img/fc_gold.ac124414.png";